var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlashcardIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_77_1804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2213 1.469C11.2775 1.26096 11.4139 1.0837 11.6006 0.976052C11.7873 0.868406 12.0091 0.839157 12.2173 0.894714L22.5373 3.65814C22.746 3.71364 22.9241 3.84974 23.0324 4.03652C23.1407 4.2233 23.1705 4.44546 23.115 4.65414L19.155 19.4279C19.0988 19.6363 18.9621 19.8138 18.775 19.9215C18.5879 20.0292 18.3658 20.0582 18.1573 20.0021L7.8373 17.2387C7.62894 17.1828 7.45127 17.0466 7.34328 16.8599C7.23528 16.6731 7.2058 16.4512 7.2613 16.2427L11.2213 1.469Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4706 4.34546L1.46035 6.76089C1.25199 6.81675 1.07432 6.95301 0.966323 7.13974C0.858332 7.32648 0.828848 7.54843 0.884345 7.75689L4.84092 22.5306C4.89713 22.739 5.0338 22.9166 5.22089 23.0243C5.40798 23.132 5.63017 23.161 5.83863 23.1049L10.9986 21.7232",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_77_1804"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlashcardIconWhite);
export default __webpack_public_path__ + "static/media/flashcard-icon-white.f5d0c5efc787f912bb11c6d9f29d74f6.svg";
export { ForwardRef as ReactComponent };